const apiURL = process.env.REACT_APP_API_URL;

async function fetchModel(clientId, token) {
  const apiUrl = `${apiURL}/admin/model/list`;

  try {
    const body = clientId ? { ClientId: clientId } : {};

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    const list = data?.message?.list || [];
    return list;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error;
  }
}

export default fetchModel;
